module.exports = __webpack_public_path__ + "static/media/thumbs-up.6c96d337.svg";